export type GoogleClickIds = {
  gclid?: string;
  gbraid?: string;
  wbraid?: string;
};

const clickIdKeys = ['gclid', 'gbraid', 'wbraid'] as const;

export function parseGoogleClickIds(search: string): GoogleClickIds {
  const params = new URLSearchParams(search);
  return Object.fromEntries(
    clickIdKeys
      .map((key) => [key, params.get(key)?.trim()] as const)
      .filter((entry): entry is [typeof clickIdKeys[number], string] => Boolean(entry[1])),
  );
}

export function hasGoogleClickId(ids: GoogleClickIds): boolean {
  return clickIdKeys.some((key) => Boolean(ids[key]));
}

export function createLeadReference(): string {
  return `DQ-${crypto.randomUUID().slice(0, 8).toUpperCase()}`;
}

export function addLeadReferenceToWhatsAppUrl(
  href: string,
  reference: string,
  locale: 'zh' | 'en',
): string {
  const url = new URL(href);
  const currentMessage = url.searchParams.get('text')?.trim() ?? '';
  const label = locale === 'en' ? 'Enquiry reference' : '查詢編號';
  url.searchParams.set(
    'text',
    `${currentMessage}${currentMessage ? '\n\n' : ''}${label}: ${reference}`,
  );
  return url.toString();
}
